/* eslint-disable valid-jsdoc */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useLayoutEffect, useRef, useState } from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import styles from './WizardStepProgressComponent.module.scss';

function jumpRenderModal(index, jumpTo, steps, step, wizardContext, customMessageModal, currentStepNameML, wizardDataWithSnapshotFlag) {
    const modalMessages = {
        title: !_.isEmpty(customMessageModal)
            ? customMessageModal.title
            : commonMessages.wantToJump,
        message: !_.isEmpty(customMessageModal)
            ? customMessageModal.message
            : commonMessages.wantToJumpMessage,
        messageProps: {
            ok: commonMessages.yes,
            close: commonMessages.close
        }
    };

    const { wizardData, wizardSnapshot, onPageJump } = wizardContext;

    let allowPageJump_Ext = true;
    if (wizardData.aspects && !(wizardData.aspects.subtreeValid && wizardData.aspects.valid)) {
        if (wizardSnapshot.aspects && wizardSnapshot.aspects.subtreeValid && wizardSnapshot.aspects.valid) {
            _.set(wizardData, 'value', _.cloneDeep(wizardSnapshot.value));
            wizardDataWithSnapshotFlag.current = true;
        } else {
            allowPageJump_Ext = false;
        }
    }

    if (allowPageJump_Ext) {
        onPageJump({
            wizardData,
            wizardSnapshot,
            modalMessages,
            index,
            currentStepNameML,
            nextStepNameML: step.mlStepName ? step.mlStepName : step.id
        });
    }
}

function RenderStep(props) {
    const {
        translator,
        steps,
        currentStepId,
        parentStepId,
        jumpTo,
        wizardContext,
        customMessageModal,
        originalSteps,
        step,
        cannotSelectStep,
        wizardDataWithSnapshotFlag
    } = props;

    const ref = useRef();
    const [width, updateWidth] = useState(0);

    useLayoutEffect(() => {
        if (ref.current) {
            updateWidth(ref.current.offsetWidth)
        }
    }, []);

    const stepHidden = _.get(step, 'stepProps.sidebarConfig.stepHidden');
    const liClassName = classNames(styles.step, {
        [styles.active]: step.id === currentStepId || step.id === parentStepId,
        [styles.notVisited]: !step.visited
    });

    if (stepHidden) {
        return null;
    }
    const originalIndexOfStep = _.findIndex(
        originalSteps,
        ({ id }) => id === step.id
    );
    const currentStepNameML = step.mlStepName;

    return (
        <li
            className={liClassName}
            key={step.id}
            onClick={() => {
                if (!cannotSelectStep) {
                    jumpRenderModal(
                        originalIndexOfStep,
                        jumpTo,
                        steps,
                        step,
                        wizardContext,
                        customMessageModal,
                        currentStepNameML,
                        wizardDataWithSnapshotFlag
                    )   
                }
            }}
        >
            <span className="container qb-progress-header__items-text" ref={ref}>
                {' '}
                {translator(step.title)}
            </span>
        </li>
    );
}



export default RenderStep;
